import one from '../assets/png/Screenshot 2022-03-17 145530.png'
import two from '../assets/png/Screenshot 2022-03-21 162917.png'
import three from '../assets/png/Screenshot 2022-03-17 153015.png'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Facebook (clone)',
        projectDesc: 'In this project we have tried to make a look alike clone of Facebook. With our efforts and the technology stack, that we have learned so far in the masai school, we were able to clone the front end with high precision and quality.',
        tags: ['React', 'CSS', 'Material Ui'],
        code: 'https://github.com/notsammy002/Facebook-clone',
        demo: 'https://facebook-clone-three-orpin.vercel.app/login',
        image: one
    },
    {
        id: 2,
        projectName: 'Electric-Car',
        projectDesc: 'Front-end Website based on Electric Cars.',
        tags: ['HTML', 'CSS', 'JS'],
        code: 'https://github.com/notsammy002/stage-1-project',
        demo: 'https://electric-car-project.netlify.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Travel_clone',
        projectDesc: 'A fully responsive website that provides Rooms and dining, Named #TravelKaro',
        tags: ['HTML', 'CSS', 'JS'],
        code: 'https://github.com/notsammy002/Travel_clone-1',
        demo: 'https://bhaskarkrp.github.io/Travel_clone/',
        image: three
    },
    {
        id: 4,
        projectName: 'Todo App',
        projectDesc: 'A html site create to take input from user and display it order wise',
        tags: ['HTML', 'CSS', 'JS'],
        code: 'https://github.com/notsammy002/todo_list_html',
        demo: 'https://github.com/notsammy002/todo_list_html',
        image: eight
    },
    {
        id: 5,
        projectName: 'Authentication page',
        projectDesc: 'It is project is which the dummy login and logout page are created the user can only access it when he/she enter the correct user and password',
        tags: ['React', 'Redux'],
        code: 'https://github.com/notsammy002/redux-auth-page',
        demo: 'https://auth-user-page.herokuapp.com/',
        image: four
    },
    {
        id: 6,
        projectName: 'Ecommerce Website',
        projectDesc: 'It is dummy Ecommerce website which has the variety of products displayed whose data is fetched from an api.',
        tags: ['React'],
        code: 'https://github.com/notsammy002/product-page-react',
        demo: 'https://online-store-masai.herokuapp.com/',
        image: five
    },
    {
        id: 7,
        projectName: 'Signup page',
        projectDesc: 'A mockup of of a singup and signin',
        tags: ['React'],
        code: 'https://github.com/notsammy002/signup-page-react',
        demo: 'https://signup-page-masai.netlify.app/',
        image: six
    },
    {
        id: 8,
        projectName: 'Stopwatch',
        projectDesc: 'Stopwatch is create the high order function in javascript',
        tags: ['React'],
        code: 'https://github.com/notsammy002/stopwatch-react',
        demo: 'https://github.com/notsammy002/stopwatch-react',
        image: seven
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/